var _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNetworkedPeople = function SvgNetworkedPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384.53 373.73",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.27 52.59s-37.18 2.12-37.18 28.68v68h74.36v-68c0-26.56-37.18-28.68-37.18-28.68z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.27,
    cy: 23.9,
    r: 23.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.51 182.41v-16.97h-8.49v16.97H32.93v25.88h8.48v-17.38h146.61v17.02h8.49v-17.02h146.61v17.38h8.48v-25.88H196.51zM37.18 277.07S0 279.2 0 305.75v68h74.36v-68c0-26.55-37.18-28.68-37.18-28.68z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.18,
    cy: 248.39,
    r: 23.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.27 277.07s-37.18 2.13-37.18 28.68v68h74.36v-68c0-26.55-37.18-28.68-37.18-28.68z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.27,
    cy: 248.39,
    r: 23.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.36 277.07s-37.18 2.13-37.18 28.68v68h74.36v-68c0-26.55-37.18-28.68-37.18-28.68z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.35,
    cy: 248.39,
    r: 23.9
  })));
};
export default SvgNetworkedPeople;